module.exports = "/images/vendor/desiigner-svg/svg/amazon-pay.svg?d61bbba853799841a86bfa88753cde95";